import type { Updater } from "@tanstack/vue-table"
import { onMounted, onUnmounted, ref, Ref } from "vue"
import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function valueUpdater<T extends Updater<any>>(updaterOrValue: T, ref: Ref) {
  ref.value = typeof updaterOrValue === "function" ? updaterOrValue(ref.value) : updaterOrValue
}

export function useIsDesktop() {
  const isDesktop = ref<boolean>(false)

  function checkDeviceType(): void {
    if (typeof window === "undefined") {
      return
    }
    isDesktop.value = window.innerWidth >= 768 // Typical breakpoint for desktop
  }

  // Check if device is desktop
  onMounted(() => {
    checkDeviceType()
    window.addEventListener("resize", checkDeviceType)
  })

  onUnmounted(() => {
    window.removeEventListener("resize", checkDeviceType)
  })

  return {
    isDesktop
  }
}
